<template>
<b-container fluid>
  <b-form class="mt-4">
    <b-row class="justify-content-center align-items-center">
      <b-col cols=4>
        <b-form-group label="Order ID:">
          <b-input-group>
            <b-form-input type="text" v-model="form.orderId" @input="searchOrder" @keydown.enter.prevent />
            <b-input-group-append is-text v-if="!!form.orderId">
              <span v-if="orderValid">✅</span>
              <b-btn size=sm class="py-0 ml-2" @click="orderForced=true" variant="warning" v-if="invalidReason.length > 0">
                ❌ Override {{ invalidReason }}
              </b-btn>
            </b-input-group-append>
          </b-input-group>

          <center><em>
            Entering an unfinished order will automatically finish the pick
          </em></center>

          <b-alert class="mt-2 py-2" small variant="danger" :show="orderForced">
            Override enabled, order ID check was bypassed!
          </b-alert>
        </b-form-group>
      </b-col>
    </b-row>
    <b-alert show v-if="pickAlert" variant=warning class="mt-2 py-2">{{ pickAlert }}</b-alert>
    <b-row class="justify-content-center align-items-center">
      <fingerprint-spinner
        :animation-duration="1500"
        :size="100"
        color="#293a93"
        class="my-3"
        v-if="picking"
      />
    </b-row>
    <section v-if="orderValid || orderForced">
      <b-row>
        <b-col>
          <b-form-group label="Ship Method">
            <b-form-select :options="shipmethods" v-model="form.shipMethodId" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Tracking #:">
            <b-form-input type="text" v-model="form.trackingNum"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Master Tracking #:">
            <b-form-input type="text" v-model="form.masterTrackingNum" placeholder="(uses tracking # if blank)"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols=6>
          <b-form-group label="Ship Time:">
            <b-input-group>
              <b-form-input type="date" v-model="form.shipDate"></b-form-input>
              <b-form-input type="time" v-model="form.shipTime"></b-form-input>
              <b-input-group-append>
                <b-btn variant="primary" @click="setTimeNow">Now</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Box Size:">
            <b-row>
              <b-col>
                <b-form-input type="number" v-model="form.boxLength"></b-form-input>
              </b-col>
              x
              <b-col>
                <b-form-input type="number" v-model="form.boxWidth"></b-form-input>
              </b-col>
              x
              <b-col>
                <b-form-input type="number" v-model="form.boxHeight"></b-form-input>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
        <b-col cols=*>
          <b-form-group label="Weight:">
            <b-form-input type="number" v-model="form.boxWeight"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Email Address:">
            <b-form-input type="text" v-model="form.emailAddress"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Customer Name:">
            <b-form-input type="text" v-model="form.customerName"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols=3>
          <b-form-group label="Send Automated Tracking Email?">
            <em v-if="form.sendTrackingEmail">(Shopify Y orders will receive an email at the end of the day, all others will go within 30 minutes)</em>
            <b-form-checkbox v-model="form.sendTrackingEmail" />
          </b-form-group>
        </b-col>
        <b-col cols=3>
          <b-form-group label="Used Customer Account?">
            <b-form-checkbox v-model="form.usedCustomerAccount" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Customer Account #" v-if="form.usedCustomerAccount">
            <b-form-input type="text" v-model="form.customerAccountNumber"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="justify-content-end align-items-end">
        <b-col cols="*" class="mr-4">
          <b-alert :show="!!this.alert" variant=danger>{{ alert }}</b-alert>
          <b-alert class="mt-2 py-2" small variant="danger" :show="orderForced">
            Override enabled, order ID check was bypassed!
          </b-alert>
          <fingerprint-spinner
            :animation-duration="1500"
            :size="300"
            color="#293a93"
            class="my-3"
            v-if="submitting"
          />
          <b-alert variant="success" show v-else-if="markedSuccess">
            Shipment submitted successfully!
          </b-alert>
        </b-col>
      </b-row>
      <b-row class="justify-content-end align-items-end">
        <b-col cols="*" class="mr-4">
          <b-btn variant="warning" @click="submit">Submit</b-btn>
        </b-col>
      </b-row>
    </section>
  </b-form>

  <hr/>

  <div class="my-2" />
  <b-form v-if="markedSuccess" @submit="combineOrder">
    <center>
      <h3>Combine Order?</h3>
    </center>
    <b-alert :show="!!combineAlert" :variant="combineAlertVariant">{{ combineAlert }}</b-alert>
    <b-row class="justify-content-center">
      <b-col cols=*>
        <b-input-group>
          <b-form-input type="text" v-model="combineOrderId" @input="searchCombineOrder" @keydown.enter.prevent />
          <b-input-group-append is-text v-if="!!combineOrderId">
            <span class="py-0 my-0">
              <b-btn v-if="combineOrderValid" variant="warning" size="sm" class="py-0 my-0 mx-2" @click="combineOrder">Combine Order</b-btn>
              <span v-else>
                <b-btn v-if="combineInvalidReason == 'unpicked'" :disabled="picking" size="sm" class="py-0 my-0 mx-2" @click="finishPick(true)" variant="primary">
                  Pick Order
                </b-btn>
                <b-btn disabled size=sm variant="danger" class="py-0 my-0 mx-2" v-else-if="!!combineInvalidReason">
                  Cannot Combine Order - {{ combineInvalidReason }}
                </b-btn>
              </span>
            </span>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="justify-content-center align-items-center">
      <fingerprint-spinner
        :animation-duration="1500"
        :size="100"
        color="#293a93"
        class="my-3"
        v-if="picking"
      />
    </b-row>
  </b-form>
</b-container>
</template>
<script>
import axios from 'axios';
const BASE_API = process.env.VUE_API_ROOT;
import { mapGetters } from 'vuex';
import { FingerprintSpinner } from 'epic-spinners';
import fishbowl from '../../helpers/services/fishbowl'
import utility from '../../helpers/utility';

export default {
  data() {
    return {
      shipmethods: [],
      form: {
        orderId: '',
        trackingNum: '',
        masterTrackingNum: '',
        shipDate: '',
        shipTime: '',
        boxLength: '11',
        boxWidth: '11',
        boxHeight: '11',
        boxWeight: '9',
        emailAddress: '',
        customerName: '',
        sendTrackingEmail: false,
        usedCustomerAccount: false,
        customerAccountNumber: '',
        shipMethodId: null,

        // calculated
        shippedAt: '',
        computerUsed: '',
        fulfilled: false,
        shippingStatus: 'To be marked as packed',
      },
      timer: undefined,
      orderValid: false,
      orderForced: false,
      invalidReason: '',

      combineOrderId: '',
      combineOrderValid: false,
      combineOrderForced: false,
      combineInvalidReason: '',
      combineOrderFulfilled: false,
      combineAlert: '',
      combineAlertVariant: 'danger',

      alert: '',
      picking: false,
      pickAlert: '',
      submitting: false,
      markedSuccess: false,
    }
  },
  computed: {
    ...mapGetters({
      canAccess: 'canAccess',
      loggedInUser: 'loggedInUser'
    }),
  },
  components: {
    FingerprintSpinner,
  },
  mounted() {
    axios.get(`${BASE_API}/fishbowl/shipping/options`).then(response => {
      this.shipmethods = [{ value: null, text: 'Select Shipping Method' }].concat(response.data.map(method => ({ value: method.scac, text: method.name })))
    }).catch(error => {
      console.error(error)
    })
  },
  methods: {
    searchOrder(_) {
      if (this.timer) { clearTimeout(this.timer) }
      this.timer = setTimeout(() => {
        this.orderValid = false
        this.orderForced = false
        this.invalidReason = ''
        this.alert = ''
        this.pickAlert = ''
        this.combineAlert = ''
        this.setTimeNow()
        axios.get(`${BASE_API}/fishbowl/order/${this.form.orderId.trim()}`).then((response) => {
          if (response.data.status == 60) {
            this.invalidReason = 'already fulfilled'
          } else if (response.data.picks.some(x => x.status.id === 40)) {
            this.orderValid = true
          } else if (response.data.picks.some(x => x.status.id === 30)) {
            this.pickAlert = 'Order unpicked... picking order!';
            this.finishPick(false);
          } else {
            this.invalidReason = 'pick not committed'
          }
          this.form.emailAddress = response.data.email
          let names = fishbowl.getAccurateNames(
            `${response.data.shippingAddress.firstName} ${response.data.shippingAddress.lastName}`,
            response.data.shippingAddress.street1
          )
          this.form.customerName = `${names.firstName} ${names.lastName}`
          let foundMethods = this.shipmethods.filter(x=>x.text === response.data.carrier)
          if (foundMethods.length == 1) {
            this.form.shipMethodId = foundMethods[0].value
          }
        }).catch((error) => {
          if (!!error.response && error.response.status == 404) {
            this.invalidReason = 'nonexistant order'
          } else {
            console.error(error)
            this.invalidReason = 'unknown error'
          }
        })
      }, 400);
    },
    async shipmentExists() {
      return axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/am-old-db/shipping/locator`,
        data: {
          orderNumber: this.form.orderId.trim(),
          trackingNumber: this.form.trackingNum,
        }
      })
    },
    finishPick(combine) {
      let id = combine ? this.combineOrderId : this.form.orderId
      this.picking = true
      axios({
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/champ/pick-finish/S${id.trim()}`
      }).then(response => {
        utility.waitResponse(response.data, () => {
          if (combine) {
            this.searchCombineOrder()
            this.combineAlertVariant = "success"
            this.combineAlert = "Pick Finished!"
          } else {
            this.searchOrder()
            this.pickAlert = "Pick Finished!"
          }
        }, (response) => {
          if (combine) {
            this.combineAlertVariant = "danger"
            this.combineAlert = response.Response
          } else {
            this.pickAlert = response.Response
          }
        }, () => {
          if (combine) {
            this.combineAlertVariant = "danger"
            this.combineAlert = "Error (DO NOT RE-SUBMIT): Request Timed Out.... Contact IT for more information."
          } else {
            this.pickAlert = "Error (DO NOT RE-SUBMIT): Request Timed Out.... Contact IT for more information."
          }
        }, (error) => {
          console.error(error);
          if (this.combine) {
            this.combineAlertVariant = "danger"
            this.combineAlert = "Error (DO NOT RE-SUBMIT): Fetching response failed.... Contact IT for support."
          } else {
            this.pickAlert = "Error (DO NOT RE-SUBMIT): Fetching response failed.... Contact IT for support."
          }
        })
      }).catch(error => {
        if (this.combine) {
          this.combineAlertVariant = "danger"
          this.combineAlert = `Pick Finish Failed! Details have been logged to the console`
        } else {
          this.pickAlert = `Pick Finish Failed! Details have been logged to the console`
        }
        console.error(error)
      }).finally(() => {
        this.picking = false
      })
    },
    setTimeNow() {
      let date = new Date()
      this.form.shipDate = `${date.getFullYear().toString().padStart(4, '0')}-${(date.getMonth()+1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
      this.form.shipTime = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`
    },
    submit(event) {
      if (event) event.preventDefault()

      this.validateForm().then(result => {
        if (!result) return

        this.alert = ''
        this.submitting = false
        this.markedSuccess = false

        this.submitting=true
        axios({
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          url: `${BASE_API}/am-old-db/shipping/insert`,
          data: this.form,
        }).then(response => {
          this.markedSuccess = true
          this.submitting = false
        }).catch(error => {
          this.alert = `Shipment Failed! Details have been logged to the console`
          console.error(error)
        })
      })
    },
    async validateForm() {
      let hasTracking = await this.shipmentExists().then(response => {
        if (response.data.length > 0) {
          this.alert = `Shipment ${this.form.trackingNum} for ${this.form.orderId} already exists!`
        } else {
          return false
        }
        return response.data.length > 0;
      }).catch(error => {
        console.error(error)
        this.alert = `Checking for Existing Orders failed! See console for details`;
        return true;
      })
      if (hasTracking) {
        return false
      }

      this.form.shippedAt = `${this.form.shipDate}T${this.form.shipTime}`
      this.form.computerUsed = `Info entry by ${this.loggedInUser.emails.value.split('@')[0]}`
      return await axios.get(`${BASE_API}/fishbowl/order/${this.form.orderId.trim()}/products`).then(response => {
        this.form.fulfilled = !response.data.some(x => x.typeid===10 && x.qtyToFulfill-x.qtyFulfilled-x.qtyPicked>0)

        let valid = Object.keys(this.form).every(key => {
          if (key === 'customerAccountNumber') {
            if (this.form.usedCustomerAccount && this.form.customerAccountNumber.trim().length == 0) {
              this.alert = 'Customer Account must be filled out!'
              return false
            } else if (!this.form.usedCustomerAccount) {
              this.form.customerAccountNumber = ''
            }
          } else if (key === 'masterTrackingNum') {
            if (this.form.trackingNum.trim().length > 0 && this.form.masterTrackingNum.trim().length === 0) {
              this.form.masterTrackingNum = this.form.trackingNum.trim()
            }
          } else if (String(this.form[key]).trim().length == 0) {
            this.alert = `${key} must be filled out!`
            return false;
          }
          return true;
        })
        if (this.form.shipMethodId === null) {
          this.alert = 'Shipping Method must be set'
          valid = false
        }

        return valid;
      }).catch(error => {
        console.error(error)
      })
    },
    searchCombineOrder() {
      if (this.timer) { clearTimeout(this.timer) }
      this.timer = setTimeout(() => {
        this.combineAlert = ''
        this.pickAlert = ''
        this.combineOrderValid = false
        this.combineOrderForced = false
        this.combineInvalidReason = false
        axios.get(`${BASE_API}/fishbowl/order/${this.combineOrderId.trim()}`).then(response => {
          if (response.data.status === 60) {
            this.combineInvalidReason = 'already fulfilled'
          } else if (response.data.picks.some(x => x.status.id === 40)) {
            this.combineOrderValid = true
            this.combineOrder();
          } else if (response.data.picks.some(x => x.status.id === 30)) {
            this.combineAlertVariant = "warning"
            this.combineAlert = 'Order unpicked... picking order!';
            this.finishPick(true);
          } else {
            this.combineAlertVariant = "danger"
            this.combineAlert = 'Order not committed... something isn\'t right here';
          }
        }).catch(error => {
          if (!!error.response && error.response.status == 404) {
            this.combineInvalidReason = 'nonexistant order'
          } else {
            console.error(error)
            this.combineInvalidReason = 'unknown error'
          }
        })
      }, 400)
    },
    combineOrder() {
      let combinedOrderId = this.combineOrderId;
      let combineText = `${combinedOrderId} Shipped with ${this.form.orderId}`;

      axios.get(`${BASE_API}/fishbowl/order/${this.form.orderId.trim()}/products`).then(response => {
        let fulfilled = !response.data.some(x => x.typeid===10 && x.qtyToFulfill-x.qtyFulfilled-x.qtyPicked>0)

        axios({
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          url: `${BASE_API}/am-old-db/shipping/insert`,
          data: {
            orderId: combinedOrderId,
            trackingNum: combineText,
            masterTrackingNum: combineText,
            shippedAt: this.form.shippedAt,
            emailAddress: this.form.emailAddress,
            customerName: this.form.customerName,
            sendTrackingEmail: this.form.sendTrackingEmail,
            usedCustomerAccount: this.form.usedCustomerAccount,
            customerAccountNumber: this.form.customerAccountNumber,
            shipMethodId: this.form.shipMethodId,
            computerUsed: this.form.computerUsed,
            shippingStatus: this.form.shippingStatus,
            fulfilled: fulfilled
          }
        }).then(response => {
          this.combineAlertVariant = "success"
          this.combineAlert = `${combinedOrderId} - Combine order Success!`
          this.combineOrderId = ''
        }).catch((error) => {
          this.combineAlertVariant = "danger"
          this.combineAlert = 'Combine order Failed! Details have been logged to the console.'
          console.error(error);
        })
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ops-info/TrackingNumberEntry.vue